import usePageTitle from "@/hooks/usePageTitle";
import { Navigate, useLocation } from "react-router-dom";
import { useConfigurationAccess } from "./access";

export default function ConfigurationIndexPage() {
  usePageTitle("/configuration", "Member 360 Configuration");
  const location = useLocation();
  const { loaded, canView: canViewGlobal } = useConfigurationAccess();

  if (!loaded) {
    return null;
  }

  // Department admins land on the only tab they may use; everyone else keeps
  // the previous destination (TabLayout still denies unauthorized users).
  const to = canViewGlobal ? `${location.pathname}/career-consultants` : `${location.pathname}/interaction-topics`;
  return <Navigate to={to} replace />;
}
